// src/api/axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({

  baseURL: "https://segesppiura.com:5003/api",
 // baseURL: "http://192.168.0.8:5003/api",

  timeout: 20000,
});

axiosInstance.interceptors.request.use((config) => {
  let token = localStorage.getItem("token");
  // si vino con prefijo, se lo quitamos
  if (token && token.startsWith("Bearer ")) token = token.slice(7);
  if (token) config.headers.Authorization = `Bearer ${token}`;

  // debug temporal (quítalo luego)
  console.log("[HTTP]", config.method?.toUpperCase(), config.baseURL + (config.url || ""),
              "auth:", !!config.headers.Authorization,
              "hdr:", String(config.headers.Authorization).slice(0, 20) + "…");
  return config;
});

export default axiosInstance;
